export default __webpack_public_path__ + "static/media/monitor.ebc385b2.png";